import { SelectInput } from '@perpay-web/components/base/SelectInput/SelectInput';
import { withFormServerErrors } from '@perpay-web/components/higher-order/WithFieldServerErrors/WithFormServerErrors';

const SelectInputServerError = withFormServerErrors(SelectInput);

export default SelectInputServerError;
